import { render, staticRenderFns } from "./saveApprovalType.vue?vue&type=template&id=3d311d99&scoped=true&"
import script from "./saveApprovalType.vue?vue&type=script&lang=js&"
export * from "./saveApprovalType.vue?vue&type=script&lang=js&"
import style0 from "./saveApprovalType.vue?vue&type=style&index=0&id=3d311d99&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d311d99",
  null
  
)

export default component.exports